<app-protectedheader></app-protectedheader>
  <app-protectedasidebar></app-protectedasidebar>

  <router-outlet></router-outlet>

<app-protectedfooter></app-protectedfooter>
